export default __webpack_public_path__ + "static/media/signinimage.fa5699f9.jpg";